import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Catalogo from './views/Catalogo'
import Contact from './views/Contact'
import MeetingRoom from './views/MeetingRoom'
import Billing from './views/billing'
import Confirmation from './views/confirmation'
import faqs from './views/faqs'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/catalogue',
            name: 'catalogo',
            component: Catalogo
        },
        {
            path: '/catalogue/:city',
            name: 'catalogoporciudad',
            component: Catalogo
        },
        {
            path: '/catalogue/:city/:checkin',
            name: 'catalogoporciudadyfecha',
            component: Catalogo
        },
        {
            path: '/meetingRoom/:roomid',
            name: 'meetingRoomdate',
            component: MeetingRoom
        },
        {
            path: '/meetingRoom/:roomid/:checkin',
            name: 'meetingRoom',
            component: MeetingRoom
        },
        {
            path: '/billing',
            name: 'billing',
            component: Billing
        },
        {
            path: '/confirmation',
            name: 'confirmation',
            component: Confirmation
        },
        {
            path: '/faqs',
            name: 'faqs',
            component: faqs
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact
        }
    ]
})
